import { useTitle } from 'react-use';

const useDocumentTitle = (title?: string) => {
  useTitle(title ? `${title} | My Account - Symmons` : 'My Account - Symmons');
};

export default useDocumentTitle;
